import axios from 'axios'

export default {
    namespaced: true,
    state: {
        localSettings: [],
    },
    mutations: {
        SET_LOCAL_SETTINGS(state, payload) {
            state.localSettings = payload;
        },
    },
    actions: {
        FetchLocalSettings({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/local-settings/fetch`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            response.data.payload.keyValuePairs = CoalesceJSON(response.data.payload.keyValuePairs);
                            commit('SET_LOCAL_SETTINGS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchLocalSettings: ${error.message}`));
            });
        },
        FetchLocalSettingsByAcademicSession({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/local-settings/fetch/academic-session/${obj.AcademicSession}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            if (response.data.payload?.keyValuePairs != null) {
                                response.data.payload.keyValuePairs = CoalesceJSON(response.data.payload.keyValuePairs);
                            }
                            commit('SET_LOCAL_SETTINGS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchLocalSettingsByAcademicSession: ${error.message}`));
            });
        },
    },
    getters: {
        LocalSettings(state) { return state.localSettings; },
    }
}
function CoalesceJSON(object, returnObject) {
    if (object == null || object == '') return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};
